import Vue from 'vue'
import HttpRouter from '@/services/HttpRouter'

export function getSurveyTemplate(uri, params) {
    return Vue.http.get(`${window.GET_SURVEY_TEMPLATE_ENDPOINT}${uri}`, { params })
}
